import { num, type ComponentForm } from '../component-types.js';

/**
 * `decal` (Unity's Decal Projector): stamps this entity's Material onto every
 * surface inside the box, projecting along the entity's -Y (down when not
 * rotated; rotate to aim at walls). Bullet holes, blood, scorch marks,
 * graffiti, puddles, rune circles, cracks with a height map
 * (see engine/docs/systems/decals.md).
 */
const form: ComponentForm = {
  key: 'decal',
  label: 'Decal',
  icon: 'image',
  order: 35,
  defaults: { size: [2, 1, 2], opacity: 1, angleFade: 70 },
  fields: [
    { key: 'size', label: 'Box size', type: { kind: 'vec3' }, hint: 'x/z = image footprint, y = projection depth (meters × scale).' },
    { key: 'opacity', label: 'Opacity', type: num(0.05, { min: 0, max: 1 }), read: (v) => v.opacity ?? 1 },
    { key: 'angleFade', label: 'Angle fade (°)', type: num(1, { min: 0, max: 90 }), read: (v) => v.angleFade ?? 70, hint: 'Surfaces turned further than this from the projector fade out.' },
    { key: 'offset', label: 'Surface offset (m)', type: num(0.001, { min: 0 }), read: (v) => v.offset ?? 0.003 },
    { key: 'terrain', label: 'On terrain', type: { kind: 'bool' }, read: (v) => v.terrain ?? true },
    { key: 'models', label: 'On models', type: { kind: 'bool' }, read: (v) => v.models ?? true },
    { key: 'receiverTags', label: 'Only on tags', type: { kind: 'tags' } },
    { key: 'sortOrder', label: 'Sort order', type: num(1, { integer: true }), hint: 'Higher draws on top of overlapping decals.' },
    { key: 'terrainResolution', label: 'Terrain detail', type: num(4, { min: 1, max: 256, integer: true }), read: (v) => v.terrainResolution ?? 32 },
  ],
};
export default form;
